import React, { useState, useEffect } from "react";
// import tote1 from "../../images/tote-1.png";
// import tote2 from "../../images/tote-6.png";
// import straw from "../../images/straw.jpeg";
// import recycle_girl_tshirt from "../../images/recycle_girl_tshirt.jpeg";
// import raccon_tshirt from "../../images/racoon_tshirt.jpeg";


import earthGirl from "../../images/earth_girl/IMG_7058.JPG";
import factory from "../../images/factory/IMG_7065.JPG";
import leafTrash from "../../images/leaf_trash/IMG_7073.JPG";
import recycleGirl from "../../images/recycling_girl/IMG_7062.JPG";

import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

const CartProduct = (props) => {
    // axios.defaults.withCredentials = true

    const value = props.v;

    const [quantity, setQuantity] = useState(Number(props.quantity));

    const [price, setPrice] = useState(Number(props.price));

    const [hidden, setHidden] = useState(false);

  
    const handleQuantityChange = event => {
        setQuantity(Number(event.target.value));
        props.updateTotal( props.total + (Number(event.target.value) * value) - price);
        setPrice((Number(event.target.value) * value));

        if (Number(event.target.value) === 0) {
            setHidden(true);
        }

        localStorage.setItem("total", props.total + (Number(event.target.value) * value) - price);

        if (localStorage.getItem("id") === null) {
            localStorage.setItem("id", uuidv4())
        }

        const Product = {
            user: localStorage.getItem("id"),
            name: props.name,
            quantity: Number(event.target.value),
            price: value
        }


        axios.post('https://ggi-store.herokuapp.com/products', Product)
            .then(res => console.log(res.data))
            .catch(err => {
                alert("Something is wrong on our side. Please try again later")
                console.log('Error: ' + err)
            });
    }
  
    const [image, setImage] = useState(``);
  
    const checkImage = (() => {
        if (props.name === "Factory Tote") {
            setImage(`${factory}`);
        }
        else if (props.name === "Recycling Girl Tote") {
            setImage(`${recycleGirl}`);
        }
        else if (props.name === "Earth Girl Tote") {
            setImage(`${earthGirl}`);
        }
        else if (props.name === "Leaf Tash Tote") {
            setImage(`${leafTrash}`);
        }
        // else if (props.name === "Recycling Girl Shirt") {
        //     setImage(`${recycle_girl_tshirt}`);
        // }
    })
  
    useEffect(() => {
        checkImage();
    }, []);
  
  
    return (
        <>
        <tr className={hidden ? "hidden" : ""} key={props.k} >
            <td> 
                <img className="p-img" src={ image } alt="tote1"/>
            </td>
            <td>{ props.name }</td>
            <td> 
                <select onChange={handleQuantityChange} value={quantity} name="quantity">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                </select>
            </td>
  
            {/* <td>{ props.quantity }</td> */}
            <td>${ quantity * value } </td>
        </tr>
        </>
    );
  };


// const CartProduct = (props) => {

//     const [quantity, setQuantity] = useState(props.quantity);

//     const handleQuantityChange = event => {
//         setQuantity(event.target.value);
//     }

//     const [image, setImage] = useState(``);

//     const checkImage = (() => {
//         if (props.name === "Pollution Tote Bag") {
//             setImage(`${tote1}`);
//         }
//         else if (props.name === "Reusable Straw and Brush") {
//             setImage(`${straw}`);
//         }
//         else if (props.name === "Recycling Girl Tote") {
//             setImage(`${tote2}`);
//         }
//     })

//     useEffect(() => {
//         checkImage();
//     });


//     return (
//         <>
//         <tr key={props.key} >
//             <td> 
//                 <img className="p-img" src={ image } alt="tote1"/>
//             </td>

//             <td>{ props.name }</td>
//             <td> 
//                 <select onChange={handleQuantityChange}  value={quantity}  name="quantity" id="quantity">
//                     <option value="0">0</option>
//                     <option value="1">1</option>
//                     <option value="2">2</option>
//                     <option value="3">3</option>
//                     <option value="4">4</option>
//                     <option value="5">5</option>
//                     <option value="6">6</option>
//                     <option value="7">7</option>
//                     <option value="8">8</option>
//                     <option value="9">9</option>
//                     <option value="10">10</option>
//                     <option value="11">11</option>
//                     <option value="12">12</option>
//                     <option value="13">13</option>
//                     <option value="14">14</option>
//                 </select>
//             </td>

//             {/* <td>{ props.quantity }</td> */}
//             <td>${ props.price } </td>
//         </tr>
//         </>
//     );
// };

export default CartProduct;
